import { render, staticRenderFns } from "./uc-menu-icon.vue?vue&type=template&id=3311ac2f&scoped=true&"
import script from "./uc-menu-icon.vue?vue&type=script&lang=ts&"
export * from "./uc-menu-icon.vue?vue&type=script&lang=ts&"
import style0 from "./uc-menu-icon.vue?vue&type=style&index=0&id=3311ac2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3311ac2f",
  null
  
)

export default component.exports